module.exports = __webpack_public_path__ + "static/media/rchic_china.d17bd051.png";